import React from 'react';
import {ReactTypeformEmbed} from 'react-typeform-embed';

const QuizLesson = ({lesson}) => (
  <div className="relative w-full max-w-5xl mx-auto rounded overflow-hidden" style={{height: '600px'}}>
    <ReactTypeformEmbed url={`https://stephen707090.typeform.com/to/${lesson.video}`} />
  </div>
);

export default QuizLesson;
